import { Body as e, Small as t } from "../../Typography/Typography.mjs";
import { Icons as n } from "../Icons/Icons.mjs";
import { Box as r } from "../Primitives/Box.mjs";
import { Flex as i, Row as a } from "../Primitives/Flex.mjs";
import { BottomBorder as o, BottomSection as s, Container as c, FooterGrid as l, FooterLinkStyled as u, FooterWrapper as d, SectionTitle as f, SocialLink as p } from "./AppFooter.styled.mjs";
import "react";
import { useTranslation as m } from "@maat/store-i18n";
import { Fragment as h, jsx as g, jsxs as _ } from "react/jsx-runtime";
//#region src/components/AppFooter/AppFooter.tsx
var v = {
	facebook: {
		label: "Facebook",
		Icon: n.Facebook
	},
	twitter: {
		label: "Twitter",
		Icon: n.Twitter
	},
	instagram: {
		label: "Instagram",
		Icon: n.Instagram
	}
}, y = (e) => e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey, b = ({ sections: n = [], socialLinks: b = [], onNavigate: x, className: S }) => {
	let { t: C } = m("ds"), w = (e) => (t) => {
		!x || t.defaultPrevented || !y(t) || (t.preventDefault(), x(e));
	};
	return /* @__PURE__ */ g(d, {
		className: S,
		children: /* @__PURE__ */ _(c, { children: [n.length > 0 && /* @__PURE__ */ _(h, { children: [/* @__PURE__ */ g(l, { children: n.map((t) => /* @__PURE__ */ _(r, { children: [/* @__PURE__ */ g(f, { children: /* @__PURE__ */ g(e, {
			weight: "semibold",
			children: t.title
		}) }), /* @__PURE__ */ g(i, {
			direction: "column",
			gap: 1.5,
			children: t.links.map((e) => /* @__PURE__ */ g(u, {
				href: e.href,
				onClick: w(e.href),
				children: e.label
			}, e.href))
		})] }, t.title)) }), /* @__PURE__ */ g(o, {})] }), /* @__PURE__ */ _(s, { children: [/* @__PURE__ */ g(t, { children: C("ds:footer.copyright") }), b.length > 0 && /* @__PURE__ */ g(a, {
			gap: 2,
			align: "center",
			children: b.map(({ network: e, href: t }) => {
				let { label: n, Icon: r } = v[e];
				return /* @__PURE__ */ g(p, {
					href: t,
					"aria-label": n,
					target: "_blank",
					rel: "noopener noreferrer",
					children: /* @__PURE__ */ g(r, { size: 18 })
				}, e);
			})
		})] })] })
	});
};
//#endregion
export { b as AppFooter };
